import { CsCultureProvider } from './culture-provider';
import { Subject }           from 'rxjs';
import * as parser           from 'accept-language-parser';
import { isNullOrUndefined } from '@cs/core';
import { Injectable }        from '@angular/core';

@Injectable({providedIn: 'root'})
export class CsCultureProviderDefault extends CsCultureProvider {

	private readonly _key = 'pref-language';
	currentCulture        = localStorage.getItem(this._key) || navigator.language;
	availableLanguages    = ['en'];

	protected translationLocation = '';

	protected cacheBusterHash         = '';
	onCultureChanged: Subject<string> = new Subject<string>();

	constructor() {
		super();
		//this.setAvailableLanguages(this.availableLanguages);
	}

	getCulture(topOnly = true): string {
		if (topOnly)
			return this.currentCulture.split('-')[0];
		else
			return this.currentCulture;
	}

	setCulture(culture) {
		this.currentCulture = culture;
		localStorage.setItem(this._key, this.currentCulture);
		this.onCultureChanged.next(culture);
	}

	setTranslationLocation(location: string) {
		this.translationLocation = location;
	}

	getTranslationLocation() {
		return this.translationLocation;
	}

	setCacheBusterHash(hash: string) {
		this.cacheBusterHash = hash;
	}

	getCacheBusterHash() {
		return this.cacheBusterHash;
	}

	setAvailableLanguages(languages: string[]) {
		this.availableLanguages = languages;
		this.currentCulture     = this.getDefaultCulture(false);

	}

	getDefaultCulture(topOnly = true): string {
		const checkLang = parser.pick(this.availableLanguages, this.currentCulture, {loose: true});
		const lang      = isNullOrUndefined(checkLang)
											? this.availableLanguages[0]
											: checkLang;
		return topOnly
					 ? lang.split('-')[0]
					 : lang;
	}

}
